import type { RawCarouselItem } from "./carousel-types";

export const carouselFallbackContent: RawCarouselItem[] = [
  {
    type: "next_meeting",
    priority: 1100,
    background: "images/tops.jpg",
    duration: 10,
  },
  {
    type: "latest_video",
    priority: 1300,
  },
  {
    type: "latest_newsletter",
    priority: 1400,
    end_date: "2026-01-01",
  },
  {
    type: "membership",
    priority: 1500,
    background: "images/multiaxis.png",
  },
];
